import React from "react";
import {
  ArrowLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowRightIcon,
} from "@chakra-ui/icons";
import {
  Flex,
  IconButton,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Tooltip,
  Text,
  Select,
} from "@chakra-ui/react";
import { TableInstance } from "react-table";

interface AdvancedTableProps {
  tableInstance: TableInstance;
  totalDocs: number;
}

const AdvancedPaginator: React.FC<AdvancedTableProps> = ({ tableInstance }) => {
  const {
    gotoPage,
    canPreviousPage,
    previousPage,
    pageOptions,
    setPageSize,
    pageCount,
    nextPage,
    canNextPage,
    state: { pageIndex, pageSize },
  } = tableInstance;
  // console.log(rows.length);

  return (
    <Flex justifyContent="space-between" m={4} alignItems="center">
      <Flex>
        <Tooltip label="Primera Página">
          <IconButton
            aria-label="button-first"
            onClick={() => gotoPage(0)}
            isDisabled={!canPreviousPage}
            icon={<ArrowLeftIcon h={3} w={3} />}
            mr={4}
          />
        </Tooltip>
        <Tooltip label="Página anterior">
          <IconButton
            aria-label="button-pag"
            onClick={previousPage}
            isDisabled={!canPreviousPage}
            icon={<ChevronLeftIcon h={6} w={6} />}
          />
        </Tooltip>
      </Flex>

      <Flex alignItems="center">
        <Text mx={8}>
          Página{" "}
          <Text fontWeight="bold" as="span">
            {pageIndex + 1}
          </Text>{" "}
          de{" "}
          <Text fontWeight="bold" as="span">
            {pageCount}
          </Text>
        </Text>
        <Text>Ir a página:</Text>{" "}
        <NumberInput
          ml={2}
          mr={8}
          w={28}
          min={1}
          max={pageOptions.length}
          onChange={(value) => {
            const num = parseInt(value);
            const page = num ? num - 1 : 0;
            gotoPage(page);
          }}
          defaultValue={pageIndex + 1}
        >
          <NumberInputField />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
        <Select
          w={32}
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[5, 10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Ver {pageSize}
            </option>
          ))}
        </Select>
      </Flex>

      <Flex ml={8}>
        <Tooltip label="Página siguiente">
          <IconButton
            aria-label="button-next"
            onClick={nextPage}
            isDisabled={!canNextPage}
            icon={<ChevronRightIcon h={6} w={6} />}
          />
        </Tooltip>
        <Tooltip label="Última Página">
          <IconButton
            aria-label="button-last"
            onClick={() => gotoPage(pageCount - 1)}
            isDisabled={!canNextPage}
            icon={<ArrowRightIcon h={3} w={3} />}
            ml={4}
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
};

export default AdvancedPaginator;
